import React from 'react';

export default () => {
    return (
        <div className="spinner__circle">
            <div className="spinner__circle-inner"></div>
        </div>
    )
}
